var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdCard = function SvgIdCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 8.61133H15.5557",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 11.3887H15.5557",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6387 3.05566H2.36095C1.97742 3.05566 1.6665 3.36658 1.6665 3.75011V16.2501C1.6665 16.6336 1.97742 16.9446 2.36095 16.9446H17.6387C18.0223 16.9446 18.3332 16.6336 18.3332 16.2501V3.75011C18.3332 3.36658 18.0223 3.05566 17.6387 3.05566Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22201 11.3893C8.3726 11.3893 9.30534 10.4566 9.30534 9.30599C9.30534 8.1554 8.3726 7.22266 7.22201 7.22266C6.07141 7.22266 5.13867 8.1554 5.13867 9.30599C5.13867 10.4566 6.07141 11.3893 7.22201 11.3893Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44434 13.472C4.7525 12.2741 5.92784 11.3887 7.22211 11.3887C8.51638 11.3887 9.6926 12.2732 9.99989 13.472",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIdCard;